"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mergesort_1 = __importDefault(require("mergesort"));
const Api = __importStar(require("../api"));
const result_1 = require("../../result");
const QuestionApi = __importStar(require("../../question"));
const level_calculator_1 = require("./level-calculator");
const question_composition_calculator_1 = require("./question-composition-calculator");
const shuffle_1 = require("./shuffle");
const distribute_with_backtracking_1 = require("./distribute-with-backtracking");
const AspectTypes = [...Api.AspectTypes, 'notCategorized'];
class Aspect {
    constructor(type, id) {
        this.type = type;
        this.id = id;
    }
    equals(other) {
        return this.type === other.type && this.id === other.id;
    }
}
const notCategorizedAspectType = 'notCategorized';
const notCategorizedAspectId = '__sys_not_categorized';
var Level;
(function (Level) {
    Level[Level["easy"] = 0] = "easy";
    Level[Level["normal"] = 1] = "normal";
    Level[Level["hard"] = 2] = "hard";
})(Level = exports.Level || (exports.Level = {}));
var QuestionAttemptType;
(function (QuestionAttemptType) {
    QuestionAttemptType[QuestionAttemptType["notAttempted"] = 0] = "notAttempted";
    QuestionAttemptType[QuestionAttemptType["attempted"] = 1] = "attempted";
})(QuestionAttemptType || (QuestionAttemptType = {}));
class AdaptiveStrategy {
    constructor() {
        this.levelCount = Object.keys(Level).filter(x => parseInt(x) >= 0).length;
        this.levelCalculator = new level_calculator_1.LevelCalculator({
            levelCount: this.levelCount,
            /**
             * The maximum level can be achieved using levels below the hardest
             */
            nonHardestMaximumLevel: 0.75,
            /**
             * How good answers will increase calculated level value in reversed order adter hardest
             */
            nonHardestReversedWeights: [2, 1],
            /**
             * How wrong answers will decrease calculated level value in reversed order after hardest
             */
            nonHardestReversedMinusWeights: [1, 2]
        });
        this.compositionCalculator = new question_composition_calculator_1.QuestionCompositionCalculator({
            levelCount: this.levelCount,
            /**
             * Distribution of non hard questions at the beginning (at level 0.0) in reversed order.
             * Eg. easy: 1, normal: 2
             */
            nonHardestReversedStartQuestions: [2, 1],
            /**
             * Distribution of non hard questions at the end (at level 1.0) in reversed order.
             * Eg. easy: 1, normal: 5
             */
            nonHardestReversedEndQuestions: [5, 1],
            /**
             * Parameters of the exponential function which describes the number of hard questions depending on level.
             */
            hardExponential: {
                c: 0.01,
                k: 4.0,
                y0: 0.2,
                x0: 0.2
            }
        });
    }
    analyze(count, questions) {
        const diffsPerAspect = [];
        const questionsByAspect = this.groupQuestionsByAspect(questions, []);
        // find minimum diff for each aspect
        for (let level = 0; level <= 1; level += 0.25) {
            const levelStatistics = this.analyzeLevel(count, questionsByAspect, level);
            for (let aspectStat of levelStatistics) {
                let current = diffsPerAspect.find(x => x.aspect.equals(aspectStat.aspect));
                if (!current) {
                    current = { aspect: aspectStat.aspect, diffsPerLevel: Array(this.levelCount).fill(0), singleLevel: false };
                    diffsPerAspect.push(current);
                }
                let usedLevelCount = 0;
                for (let i = 0; i < this.levelCount; i++) {
                    current.diffsPerLevel[i] = Math.round(Math.min(current.diffsPerLevel[i], aspectStat.diffsPerLevel[i]));
                    if (aspectStat.countsPerLevel[i] > 0) {
                        usedLevelCount++;
                    }
                }
                if (usedLevelCount === 1) {
                    current.singleLevel = true;
                }
            }
        }
        const result = [];
        diffsPerAspect.forEach(x => {
            const diffs = [];
            for (let level = 0; level < this.levelCount; level++) {
                if (x.diffsPerLevel[level] < 0) {
                    diffs.push({ level: this.demapLevel(level), diff: x.diffsPerLevel[level] });
                }
            }
            if (diffs.length > 0 || x.singleLevel) {
                result.push({
                    aspect: x.aspect,
                    singleLevel: x.singleLevel,
                    diffs: diffs
                });
            }
        });
        return result;
        // const level = 1
        // const questionsByAspect = this.groupQuestionsByAspect(questions, [])
        // const compositionByAspect = questionsByAspect.map(x => {
        //   const diff = Math.random() * 0.4 - 0.2
        //   const composition = this.calculateAspectComposition(x.questionStatistics, level)
        //   return {
        //     aspect: x.aspect,
        //     level: level + diff,
        //     composition: composition,
        //     questions: x.questions
        //   }
        // })
        // const distributed = this.distributeQuestions(count, compositionByAspect)
        // console.log('DISTRIBUTED', distributed, count)
        // if (distributed.success) {
        //   const statistics = questionsByAspect.map((x) => {
        //     const a = distributed.result.diffsPerLevel.find(y => y.aspect.equals(x.aspect))
        //     return { aspect: x.aspect,
        //              composition: compositionByAspect.find(y=> y.aspect.equals(x.aspect))!.composition,
        //              questionCounts: x.questionStatistics.questionCounts,
        //              usedCounts: a ? a.questionsPerLevel : null,
        //              diffs: a ? a.diffsPerLevel : null }
        //   })
        //   console.log('ANALYZE', count, statistics)
        //   console.log('SUM', statistics.reduce((x, y) => x + y.usedCounts!.reduce((z, v) => z + v, 0) ,0))
        // }
    }
    analyzeLevel(count, questionsByAspect, level) {
        const compositionByAspect = questionsByAspect.map(x => {
            const composition = this.calculateAspectComposition(x.questionStatistics, level);
            return {
                aspect: x.aspect,
                level: level,
                composition: composition,
                questions: x.questions
            };
        });
        const distributed = this.distributeQuestions(count, compositionByAspect);
        //console.log('DISTRIBUTED', distributed, count)
        if (!distributed.success) {
            throw new Error('Not enough question, it might be a coding error');
        }
        return distributed.value.statistics;
        // if (distributed.success) {
        //   const statistics = questionsByAspect.map((x) => {
        //     const a = distributed.result.diffsPerLevel.find(y => y.aspect.equals(x.aspect))
        //     return { aspect: x.aspect,
        //              composition: compositionByAspect.find(y=> y.aspect.equals(x.aspect))!.composition,
        //              questionCounts: x.questionStatistics.questionCounts,
        //              usedCounts: a ? a.questionsPerLevel : null,
        //              diffs: a ? a.diffsPerLevel : null }
        //   })
        //   console.log('ANALYZE', count, statistics)
        //   console.log('SUM', statistics.reduce((x, y) => x + y.usedCounts!.reduce((z, v) => z + v, 0) ,0))
        // }
    }
    calculate(count, questions, attempts) {
        const questionsByAspect = this.groupQuestionsByAspect(questions, attempts);
        const compositionByAspect = questionsByAspect.map(x => {
            const level = this.calculateAspectLevel(x.questionStatistics);
            const composition = this.calculateAspectComposition(x.questionStatistics, level);
            return {
                aspect: x.aspect,
                level: level,
                composition: composition,
                questions: x.questions
            };
        });
        console.log('COMPOSITION BY ASPECT', compositionByAspect);
        const distributed = this.distributeQuestions(count, compositionByAspect);
        if (!distributed.success) {
            return distributed;
        }
        return result_1.ok(distributed.value.questionIds);
    }
    calculateLevel(questions, attempts) {
        const questionsByAspect = this.groupQuestionsByAspect(questions, attempts);
        const levelByAspect = questionsByAspect.map(x => {
            const level = this.calculateAspectLevel(x.questionStatistics);
            return {
                aspect: x.aspect,
                questionCount: x.questionStatistics.questionCount,
                level: level,
            };
        });
        const sumQuestions = levelByAspect.reduce((x, y) => x + y.questionCount, 0);
        const level = levelByAspect.reduce((x, y) => {
            const weight = y.questionCount / sumQuestions;
            const aspectWeightedLevel = y.level * weight;
            return x + aspectWeightedLevel;
        }, 0);
        return {
            levelByAspect: levelByAspect,
            level: level
        };
    }
    distributeQuestions(count, compositionByAspect) {
        const distributedQuestions = this.distributeQuestionsBetweenAspects(count, compositionByAspect);
        if (distributedQuestions === 'not-enough-question') {
            return result_1.err('not-enough-question');
        }
        let finalQuestions = [];
        let minDiffs = [];
        // distribute questions inside an aspect
        for (let aspectDistribution of distributedQuestions) {
            const aspect = compositionByAspect.find(x => x.aspect.equals(aspectDistribution.aspect));
            if (!aspect) {
                throw new Error('Coding error');
            }
            const requiredQuestion = aspectDistribution.count;
            const notUsedQuestions = aspect.questions.filter(x => finalQuestions.findIndex(y => y.id === x.id) < 0);
            const [distribution, requiredDistribution, minDiffPerLevel, countsPerLevel] = this.distributeQuestionsBetweenLevels(requiredQuestion, notUsedQuestions, aspect.composition);
            if (distribution === 'not-enough-question') {
                return result_1.err('not-enough-question-inside-aspect');
            }
            // add questions for each levels
            let questionsPerLevel = Array(this.levelCount).fill(0);
            for (let level = 0; level < this.levelCount; level++) {
                const questions = this.addQuestions(notUsedQuestions, level, distribution[level]);
                if (questions === false) {
                    return result_1.err('not-enough-question-inside-level');
                }
                questionsPerLevel[level] = questions.length;
                questions.forEach(x => {
                    finalQuestions.push(x);
                });
            }
            minDiffs.push({ aspect: aspect.aspect,
                countsPerLevel: countsPerLevel,
                resultQuestionsPerLevel: questionsPerLevel,
                requiredDistribution: requiredDistribution,
                diffsPerLevel: minDiffPerLevel });
        }
        const finalQuestionIds = shuffle_1.shuffle(finalQuestions.map(x => x.id));
        return result_1.ok({
            questionIds: finalQuestionIds,
            statistics: minDiffs
        });
    }
    calculateAspectLevel(statistics) {
        const level = this.levelCalculator.calculate(statistics.questionCounts, statistics.goodCounts, statistics.wrongCounts);
        return level;
    }
    calculateAspectComposition(statistics, level) {
        return this.compositionCalculator.calculate(statistics.questionCounts, level);
    }
    averageAspectCount(questions) {
        const aspectCount = questions.map(q => {
            let count = 0;
            for (let type of AspectTypes) {
                count += (q.aspects[type] || []).length;
            }
            return count;
        }).reduce((x, y) => x + y, 0);
        const averageAspectCount = aspectCount / questions.length;
        return averageAspectCount;
    }
    distributeQuestionsBetweenAspects(count, compositionByAspect) {
        // Calculate a weight which represents that how many question of the aspect is used
        // in other aspects too. It is used for ordering, aspects with lower weight comes first.
        const withAverageAspects = compositionByAspect.map(x => ({
            ...x,
            averageQuestionAspectWeight: this.averageAspectCount(x.questions) * x.questions.length
        }));
        withAverageAspects.sort((x, y) => {
            const levelDiff = x.level - y.level;
            if (levelDiff !== 0) {
                return levelDiff;
            }
            const aspectDiff = x.averageQuestionAspectWeight - y.averageQuestionAspectWeight;
            return aspectDiff;
        });
        const usedQuestions = [];
        let weights = [];
        for (let aspect of withAverageAspects) {
            const notUsedQuestions = aspect.questions.filter(x => usedQuestions.indexOf(x.id) < 0);
            const notUsedCount = notUsedQuestions.length;
            weights.push({
                weight: 1 - aspect.level,
                count: notUsedCount
            });
            notUsedQuestions.forEach(x => { usedQuestions.push(x.id); });
        }
        const distributedQuestions = distribute_with_backtracking_1.distributeWithBacktracking(weights, count);
        if (distributedQuestions === 'not-enough-question') {
            return distributedQuestions;
        }
        return distributedQuestions.map((x, i) => {
            const aspect = withAverageAspects[i];
            return {
                aspect: aspect.aspect,
                count: x
            };
        });
    }
    distributeQuestionsBetweenLevels(count, questions, composition) {
        const levelCount = this.levelCount;
        let countsByLevel = Array(levelCount).fill(0);
        for (let question of questions) {
            countsByLevel[question.level]++;
        }
        const distributionInput = countsByLevel.map((x, i) => ({
            count: x,
            weight: composition[i]
        }));
        // distribute the questions between levels
        const sum = distributionInput.reduce((x, y) => x + y.weight, 0);
        const requiredDistribution = sum > 0 ? distributionInput.map(x => count / sum * x.weight) :
            Array(distributionInput.length).fill(0);
        let minDiffPerLevel = Array(levelCount).fill(Number.MIN_SAFE_INTEGER);
        const distribution = distribute_with_backtracking_1.distributeWithBacktracking(distributionInput, count);
        minDiffPerLevel = countsByLevel.map((x, i) => {
            const diff = x - requiredDistribution[i];
            return diff < 0 ? diff : 0;
        });
        return [distribution, requiredDistribution, minDiffPerLevel, countsByLevel];
    }
    addQuestions(questions, level, count) {
        let filtered = questions.filter(x => x.level === level);
        if (count > filtered.length) {
            // we need more questions than available
            return false;
        }
        // randomize order which will be the base of stable sort
        filtered = shuffle_1.shuffle(filtered);
        // sort using stable merge sort to do not change shuffled order of the questions
        filtered = mergesort_1.default((x, y) => {
            return this.questionComparer(x, y);
        }, filtered);
        if (filtered.length < count) {
            return false;
        }
        return filtered.slice(0, count);
    }
    questionComparer(x, y) {
        // neither of them attempted
        if (x.attempt.type === QuestionAttemptType.notAttempted &&
            y.attempt.type === QuestionAttemptType.notAttempted) {
            // order by score in reverse manner
            return y.maxScore - x.maxScore;
        }
        // both of them attempted
        if (x.attempt.type === QuestionAttemptType.attempted &&
            y.attempt.type === QuestionAttemptType.attempted) {
            function achieved(min, max, score) {
                if (max - min === 0) {
                    return 0;
                }
                return (score - min) / (max - min);
            }
            // compare by score
            const xScore = achieved(x.minScore, x.maxScore, x.attempt.achievedScore);
            const yScore = achieved(y.minScore, y.maxScore, y.attempt.achievedScore);
            const scoreDiff = xScore - yScore;
            if (Math.abs(scoreDiff) > 0.01) { // calculate with floating point error
                return scoreDiff;
            }
            // compare by thinking time
            const thinkDiff = x.attempt.thinkingTimeSeconds - y.attempt.thinkingTimeSeconds;
            if (thinkDiff !== 0) {
                return thinkDiff;
            }
            // compare by attempt count
            return x.attempt.attemptCount - y.attempt.attemptCount;
        }
        // one of them is attempted
        if (x.attempt.type === QuestionAttemptType.notAttempted) {
            return -1;
        }
        else {
            return 1;
        }
    }
    groupQuestionsByAspect(questions, questionAttempts) {
        const levelCount = this.levelCount;
        const aspects = [];
        for (let question of questions) {
            const details = this.questionDetails(question, questionAttempts);
            let hasAspect = false;
            const aspectTypes = Object.keys(question.aspects);
            for (let aspect of aspectTypes) {
                for (let id of question.aspects[aspect]) {
                    hasAspect = true;
                    const aspectMeta = getOrCreate(aspect, id);
                    aspectMeta.questions.push(details);
                }
            }
            if (!hasAspect) {
                const aspectMeta = getOrCreate(notCategorizedAspectType, notCategorizedAspectId);
                aspectMeta.questions.push(details);
            }
        }
        const result = aspects.map(x => ({
            aspect: x.aspect,
            questions: x.questions,
            questionStatistics: questionStatistics(x.questions)
        }));
        return result;
        function getOrCreate(type, id) {
            const aspect = new Aspect(type, id);
            let value = aspects.find(x => x.aspect.equals(aspect));
            if (!value) {
                value = { aspect: aspect, questions: [] };
                aspects.push(value);
            }
            return value;
        }
        function questionStatistics(questions) {
            let questionCounts = Array(levelCount).fill(0);
            let goodCounts = Array(levelCount).fill(0);
            let wrongCounts = Array(levelCount).fill(0);
            for (let question of questions) {
                const level = question.level;
                questionCounts[level]++;
                if (question.attempt.type === QuestionAttemptType.notAttempted) {
                    continue;
                }
                const attemptScore = question.attempt.achievedScore;
                if (attemptScore == question.maxScore) {
                    goodCounts[level]++;
                }
                else {
                    wrongCounts[level]++;
                }
            }
            return {
                questionCount: questions.length,
                questionCounts: questionCounts,
                goodCounts: goodCounts,
                wrongCounts: wrongCounts
            };
        }
    }
    questionDetails(question, questionAttempts) {
        let attemptDetails;
        const attempts = questionAttempts.find(x => x.id === question.id);
        if (!attempts || attempts.attempts.length === 0) {
            attemptDetails = {
                type: QuestionAttemptType.notAttempted
            };
        }
        else {
            const length = attempts.attempts.length;
            const last = attempts.attempts[length - 1];
            attemptDetails = {
                type: QuestionAttemptType.attempted,
                thinkingTimeSeconds: last.thinkingTimeSeconds,
                achievedScore: last.achievedScore,
                attemptCount: length
            };
        }
        return {
            id: question.id,
            minScore: question.minScore,
            maxScore: question.maxScore,
            level: mapLevel(question.level),
            attempt: attemptDetails,
            aspects: question.aspects
        };
        function mapLevel(level) {
            switch (level) {
                case QuestionApi.QuestionLevel.easy:
                    return Level.easy;
                case QuestionApi.QuestionLevel.normal:
                    return Level.normal;
                case QuestionApi.QuestionLevel.hard:
                    return Level.hard;
                default:
                    throw new Error(`Invalid level ${level}`);
            }
        }
    }
    demapLevel(level) {
        switch (level) {
            case Level.easy:
                return QuestionApi.QuestionLevel.easy;
            case Level.normal:
                return QuestionApi.QuestionLevel.normal;
            case Level.hard:
                return QuestionApi.QuestionLevel.hard;
        }
    }
}
exports.AdaptiveStrategy = AdaptiveStrategy;
//# sourceMappingURL=adaptive-strategy.js.map